import { request } from '../../api';

/**
 * Журнал действий и лента событий.
 *
 * Оба маршрута существуют в ядре, но до этого раздела их не звал никто:
 * `audit_entry` писалась на каждой операции с деньгами, бонусами и ПДн и
 * читалась только запросом в базу.
 */

export interface AuditActor {
  readonly type?: string;
  readonly id?: string;
  readonly displayName?: string;
}

export interface AuditRow {
  readonly id: string;
  readonly actor: AuditActor | null;
  readonly action: string;
  readonly entityType: string;
  readonly entityId: string | null;
  readonly siteId: string | null;
  readonly before: unknown;
  readonly after: unknown;
  readonly createdAt: string;
  readonly requestId: string | null;
  readonly ip: string | null;
  readonly userAgent: string | null;
}

export interface AuditPage {
  readonly items: readonly AuditRow[];
  readonly nextCursor: string | null;
}

export interface AuditFilter {
  readonly action?: string;
  readonly entityType?: string;
  readonly entityId?: string;
  readonly actorId?: string;
  readonly siteId?: string;
  readonly from?: string;
  readonly to?: string;
  readonly cursor?: string;
  readonly limit?: number;
}

function query(filter: AuditFilter): string {
  const params = new URLSearchParams();
  if (filter.action) params.set('action', filter.action);
  if (filter.entityType) params.set('entity_type', filter.entityType);
  if (filter.entityId) params.set('entity_id', filter.entityId);
  if (filter.actorId) params.set('actor_id', filter.actorId);
  if (filter.siteId) params.set('site_id', filter.siteId);
  if (filter.from) params.set('from', filter.from);
  if (filter.to) params.set('to', filter.to);
  if (filter.cursor) params.set('cursor', filter.cursor);
  params.set('limit', String(filter.limit ?? 50));
  return params.toString();
}

export function fetchAudit(filter: AuditFilter): Promise<AuditPage> {
  return request<AuditPage>('GET', `/api/v1/audit?${query(filter)}`);
}

export interface Facet {
  readonly value: string;
  readonly count: number;
}

export function fetchFacets(days = 30): Promise<{
  readonly actions: readonly Facet[];
  readonly entityTypes: readonly Facet[];
}> {
  return request('GET', `/api/v1/audit/facets?days=${days}`);
}

export interface EventRow {
  readonly id: string;
  readonly kind: string;
  readonly entityType: string | null;
  readonly entityId: string | null;
  readonly siteId: string | null;
  readonly payload: unknown;
  readonly occurredAt: string;
}

export function fetchEvents(
  options: { before?: string; limit?: number } = {},
): Promise<readonly EventRow[]> {
  const params = new URLSearchParams();
  // Человеку нужны последние события сверху. Лента для интеграций читается
  // вперёд от курсора, и по умолчанию маршрут отдаёт именно её порядок.
  params.set('order', 'desc');
  if (options.before) params.set('before', options.before);
  params.set('limit', String(options.limit ?? 100));
  return request<readonly EventRow[]>('GET', `/api/v1/events?${params.toString()}`);
}
